import React from 'react';
import { SubscriptionInfo } from 'features/profile/component/subscription-info/subscription-info';

/**
 * Subscription Tab Component
 * 
 * A settings tab component that displays subscription information and management.
 * This tab is used within the SettingsDialog to provide subscription details,
 * billing information, and subscription management options.
 * 
 * Features:
 * - Current plan details
 * - Billing information
 * - Subscription management (upgrade, cancel)
 * - Integration with the existing settings dialog structure
 * - Responsive design that works on both desktop and mobile
 * 
 * @param tabId - The ID of the current tab (used for consistency with other tabs)
 * @returns A subscription information tab component
 */

interface SubscriptionTabProps {
    tabId: string;
}

export const SubscriptionTab: React.FC<SubscriptionTabProps> = () => {
    return (
        <div className="h-full overflow-auto bg-background">
            <SubscriptionInfo showSubscriptionInfo={true} />
        </div>
    );
};

